<script lang="ts">
  import DefaultLayout from '../default-layout/DefaultLayout.svelte'

  type Props = {
    content?: string
  }

  const { content }: Props = $props()
</script>

<DefaultLayout>
  {#if content}
    <div class="html-content">
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html content}
    </div>
  {/if}
</DefaultLayout>

<style lang="scss">
  .html-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 1rem;
    max-width: 60rem;
    margin: 0 auto;

    :global(h1) {
      font-size: 1.5rem;
      font-weight: 600;
    }

    :global(h2) {
      font-size: 1.25rem;
      font-weight: 600;
    }

    :global(h3) {
      font-size: 1rem;
      font-weight: 600;
    }

    :global(strong) {
      font-weight: 600;
    }

    :global(ul) {
      list-style: disc;
      padding-left: 1rem;
    }
  }
</style>
